module.exports = __webpack_public_path__ + "static/media/ball7.cade3070.webp";